import React from 'react';
import Heading from '../../Heading/JavaScript/Heading';
import SkillsData from '../Data/SkillsData';
import Card from './Card';

function Technologies() {
    return (
        <section className="skills">
            <Heading heading="Technologies" />
            <div className="skills__cards">
                {
                    SkillsData.map(
                        (skill) => (
                            <Card name={skill["name"]} icon={skill["icon"]} text={skill["text"]} link={skill["link"]} />
                        )
                    )   
                }
            </div>
        </section>
    );
}

export default Technologies



// WEBPACK FOOTER //
// ./src/Components/Technologies/JavaScript/Technologies.js